import { cn } from "@/lib/utils";
import { useCitationMode, type CitationMode } from "./use-citation-mode";
import { AlignLeft, Rows3 } from "lucide-react";

interface CitationModeToggleProps {
  className?: string;
}

export function CitationModeToggle({ className }: CitationModeToggleProps) {
  const [mode, setMode] = useCitationMode();

  const options: Array<{
    value: CitationMode;
    label: string;
    icon: typeof AlignLeft;
  }> = [
    { value: "compact", label: "Compact", icon: AlignLeft },
    { value: "annotated", label: "Annotated", icon: Rows3 },
  ];

  return (
    <div
      className={cn(
        "inline-flex items-center rounded-lg border bg-muted p-0.5",
        className,
      )}
    >
      {options.map((opt) => {
        const Icon = opt.icon;
        const active = mode === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => setMode(opt.value)}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-medium transition-colors",
              active
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            <Icon className="h-3.5 w-3.5" />
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
